import { flushSync } from "react-dom";
import { createRoot } from "react-dom/client";

// Reuse roots without retaining detached containers that an external UI library owns.
const reactRoots = new WeakMap();

export const renderReactNode = (node, container, sync = false) => {
  let root = reactRoots.get(container);

  if (!root) {
    root = createRoot(container);
    reactRoots.set(container, root);
  }

  const render = () => root.render(node);
  if (sync) {
    flushSync(render);
  } else {
    render();
  }

  return container;
};
